<template>
  <div class="container-fluid border-top">
      <div class="py-3  mt-2 text-left">
          <span class="lead pl-3 font-weight-bold">
                Add Vessel
          </span>
          <span class="float-right text-small">
             <button class="btn btn btn-primary btn-sm ml-3" @click="saveVessel">Save Changes</button>
                <button class="btn btn-dark btn-sm ml-3" @click="goBack">GO BACK</button>
          </span>
      </div>
      <div class="row d-block mx-auto" >
        <img
            width="250"
            class="border vessel-pic"
            alt="Vessel Image"
            :src="vessel_image || require(`@/assets/crew.png`)"

        />

      </div>
      <div style="text-align: left">
        <div class="row mb-2">
          <div class="col-12">
            <h4>General Information</h4>

            <div class="row">
              <div class="col-6">
                <div class="form-group row">
                  <label for="vessel-name" class="col-sm-4 col-form-label" >
                    Vessel Name
                  </label>
                  <div class="col-8">
                    <input type="text"
                           class="form-control" id="vessel-name"
                           v-model="vesselFields.name"
                           placeholder="Vessel Name"
                    />
                  </div>
                </div>
                <div class="form-group row">
                  <label for="vessel-image-file" class="col-sm-4 col-form-label" >
                    Vessel Image
                  </label>
                  <div class="col-8">
                    <input
                        type="file" name="vessel-image-file" id="vessel-image-file"
                        accept="image/jpeg"
                        @change="changeImage($event)"
                    >
                  </div>
                </div>
                <div class="form-group row">
                  <label for="vessel-code" class="col-sm-4 col-form-label">
                    Vessel Code
                  </label>
                  <div class="col-8">
                    <input
                        type="text"
                        class="form-control" id="vessel-code"
                        placeholder="Vessel Code"
                        v-model="vesselFields.code"
                    >
                  </div>
                </div>
                <div class="form-group row">
                  <label for="vessel-type" class="col-sm-4 col-form-label">
                    Vessel Type
                  </label>
                  <div class="col-8">
                    <select
                        class="form-control"
                        id="vessel-type"
                        v-model="vesselFields.vessel_type_id"
                    >
                      <option :value="null">-- Select Vessel Type --</option>
                      <option v-show="vesselTypeKey.name!=='' ||vesselTypeKey.name!=null "
                              :key="vesselTypeKey.id"
                              :value="vesselTypeKey.id"
                              v-for="vesselTypeKey in vesselTypeKeys"
                      >
                        {{vesselTypeKey.name}}
                      </option>
                    </select>
                  </div>
                </div>
                <div class="form-group row">
                  <label for="vessel-group" class="col-sm-4 col-form-label">
                    Vessel Group
                  </label>
                  <div class="col-8">
                    <select
                        class="form-control"
                        id="vessel-group"
                        v-model="vesselFields.vessel_group_id"
                    >
                      <option :value="null">-- Select Vessel Group --</option>
                      <option v-show="vesselGroupKey.name!=='' ||vesselGroupKey.name!=null "
                              :key="vesselGroupKey.id"
                              :value="vesselGroupKey.id"
                              v-for="vesselGroupKey in vesselGroupKeys"
                      >
                        {{vesselGroupKey.name}}
                      </option>
                    </select>
                  </div>
                </div>
                <div class="form-group row">
                  <label for="insurance" class="col-sm-4 col-form-label">
                    Insurance
                  </label>
                  <div class="col-8">
                    <input type="text"
                           class="form-control"
                           id="insurance" placeholder="Insurance"
                           v-model="vesselFields.insurance"
                    >
                  </div>
                </div>
                <div class="form-group row">
                  <label for="cba-type" class="col-sm-4 col-form-label">
                    CBA Type
                  </label>
                  <div class="col-8">
                    <input
                        type="text"
                        class="form-control" id="cba-type"
                        placeholder="CBA Type"
                        v-model="vesselFields.cba_type"
                    >
                  </div>
                </div>
              </div>
              <div class="col-6" style="text-align: left;">
                <div class="form-group row">
                  <label for="registry-port" class="col-sm-4 col-form-label">
                    Registry Port
                  </label>
                  <div class="col-8">
                    <select
                        class="form-control"
                        id="registry-port"
                        v-model="vesselFields.port_id"
                    >
                      <option :value="null">-- Select Registry Port --</option>
                      <option v-show="portKey.name!=='' ||portKey.name!=null "
                              :key="portKey.id"
                              :value="portKey.id"
                              v-for="portKey in portKeys"
                      >
                        {{portKey.name}}
                      </option>
                    </select>
                  </div>
                </div>
                <div class="form-group row">
                  <label for="flag" class="col-sm-4 col-form-label">
                    Flag
                  </label>
                  <div class="col-8">
                    <select
                        class="form-control"
                        id="flag"
                        v-model="vesselFields.flag_id"

                    >
                      <option :value="null">-- Select Flag --</option>
                      <option v-show="countryKey.name!=='' ||countryKey.name!=null "
                              :key="countryKey.id"
                              :value="countryKey.id"
                              v-for="countryKey in countryKeys"
                      >
                        {{countryKey.name}}
                      </option>
                    </select>
                  </div>
                </div>
                <div class="form-group row">
                  <label for="imo" class="col-sm-4 col-form-label">
                    IMO NO.
                  </label>
                  <div class="col-8">
                    <input type="text"
                           class="form-control" id="imo"
                           placeholder="IMO"
                           v-model="vesselFields.imo_no">
                  </div>
                </div>
                <div class="form-group row">
                  <label for="official-no" class="col-sm-4 col-form-label">
                    Official No.
                  </label>
                  <div class="col-8">
                    <input type="text" class="form-control" id="official-no" placeholder="Official No."
                           v-model="vesselFields.official_no"
                    >
                  </div>
                </div>
                <div class="form-group row">
                  <label for="japan-coastal" class="col-sm-4 col-form-label">
                    Japan Coastal
                  </label>
                  <div class="col-8">
                    <input type="text"
                           class="form-control" id="japan-coastal"
                           placeholder="Japan Coastal"
                           v-model="vesselFields.japan_coastal"
                    >
                  </div>
                </div>
                <div class="form-group row">
                  <label for="poea-principal" class="col-sm-4 col-form-label">
                    POEA Principal
                  </label>
                  <div class="col-8">
                    <input type="text" class="form-control"
                           id="poea-principal" placeholder="POEA Principal"
                           v-model="vesselFields.poea_principal"
                    >
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="row">
           <div class="col-6">
              <h4 class="mb-3">Assigned Manning</h4>
              <div class="form-group">
                <div v-for="manningKey in manningKeys" :key="manningKey.id">
                  <div class="form-check d-flex">
                    <input
                        type="checkbox"
                        name=""
                        class="form-check-input"
                        :value="manningKey.id"
                        :id="'manningKey' + manningKey.id"
                        v-model="vesselFields.mannings"
                    >
                    <label
                        class="form-check-label"
                        :for="'manningKey' + manningKey.id"
                    >
                      {{ manningKey.alias }}
                    </label>
                  </div>
                </div>
              </div>
            </div>
          <div class="col-6">
            <h4 class="mb-3">ECDIS Type</h4>
            <div class="form-group">
              <div v-for="ecdisKey in ecdisKeys" :key="ecdisKey.id">
                <div class="form-check d-flex">
                  <input
                      class="form-check-input"
                      type="checkbox"
                      :value="ecdisKey.id"
                      :id="'ecdisKey' + ecdisKey.id"
                      v-model="vesselFields.vessel_ecdis"
                  />
                  <label
                      class="form-check-label"
                      :for="'ecdisKey' + ecdisKey.id"
                  >
                    {{ ecdisKey.name }}
                  </label>
                </div>
            </div>
          </div>
        </div>
      </div>
      </div>
  </div>
</template>

<script>
import {vueAppMixin} from "@/mixins/vueAppMixin";
import {mapActions, mapGetters} from "vuex";


export default {
  name: "AddVessel",
  mixins:[vueAppMixin],
  data(){
    return{
      vesselFields:{
        vessel_type_id: null,
        vessel_group_id: null,
        port_id: null,
        flag_id:null,
        mannings: [],
        vessel_ecdis: [],
      },
      vessel_image:null,
    }

  },
  computed:{
    ...mapGetters([
      "manningKeys",
      "vesselTypeKeys",
      "vesselGroupKeys",
      "portKeys",
      "countryKeys",
      "ecdisKeys",
    ])
  },
  methods:{
    ...mapActions(['addVessel']),
    async saveVessel(){
      let formData=new FormData();
      if(await this.confirmCreateAlert()){
        let imagefile=document.getElementById('vessel-image-file');
        if(imagefile.files && imagefile.files[0]){
          formData.append('vessel_image',imagefile.files[0]);
        }
        Object.keys(this.vesselFields).forEach((key)=>{
          if (this.vesselFields[key] === null) {
            return
          }

          if(key==='mannings' || key === 'vessel_ecdis'){
            let list=this.vesselFields[key];
            for(let i=0; i<list.length;i++){
              formData.append(`${key}[]`,list[i]);
            }
          }
          else{
            formData.set(key,this.vesselFields[key]);
          }
        })
        let vessel=await this.addVessel(formData)
        if(!vessel.errors) {
          this.successAlert('Created Successfully','Vessel')
          await this.$router.push({name: 'VesselIndex'});
        }
      }
    },
    changeImage(event){
      this.vessel_image=URL.createObjectURL(event.target.files[0]);
    }
  }
}
</script>

<style scoped>

</style>
